import Vue from "vue";
import Router from "vue-router";

import store from "@/store/";

import Login from "@/views/LogIn";
import CategoryList from "@/views/CategoryList";
import ProductList from "@/views/ProductList";
import ProductDetail from "@/views/ProductDetail";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      name: "login",
      path: "/login",
      component: Login
    },
    {
      name: "categoryList",
      path: "/",
      alias: "/category",
      component: CategoryList,
      beforeEnter(to, from, next) {
        if (store.state.user.loggedIn === true) {
          next();
        } else {
          next("/login");
        }
      }
    },
    {
      name: "productList",
      path: "/category/:categoryId",
      props: true,
      component: ProductList,
      beforeEnter(to, from, next) {
        if (store.state.user.loggedIn === true) {
          next();
        } else {
          next("/login");
        }
      }
    },
    {
      name: "productDetail",
      path: "/category/:categoryId/product/:id",
      props: true,
      component: ProductDetail,
      beforeEnter(to, from, next) {
        if (store.state.user.loggedIn === true) {
          next();
        } else {
          next("/login");
        }
      }
    }
  ]
});
